import { route } from 'preact-router';
import { visits, searchQuery, filterEstado, isDesktopAdmin, dataLoading } from '../store/state';
import { Shell } from '../layout/Shell';
import { VisitCard } from '../components/VisitCard';
import { VisitsTable } from '../components/VisitsTable';
import { ListSkeleton } from '../components/Skeleton';
import { Icon } from '../components/Icon';

export function AgendaView() {
  const dt = isDesktopAdmin.value;
  let vs = visits.value;
  if (searchQuery.value) {
    const q = searchQuery.value.toLowerCase();
    vs = vs.filter(
      (v) =>
        (v.client?.nombre || '').toLowerCase().includes(q) ||
        (v.tecnico?.nombre || '').toLowerCase().includes(q)
    );
  }
  if (filterEstado.value) vs = vs.filter((v) => v.estado === filterEstado.value);

  const sinTomar = vs.filter((v) => !v.tecnicoId && v.estado === 'agendada');
  const pen = vs.filter(
    (v) =>
      v.tecnicoId &&
      !['completada', 'cancelada', 'fallida', 'pospuesta'].includes(v.estado)
  );
  const comp = vs.filter((v) => v.estado === 'completada');

  if (dataLoading.value) {
    return (
      <Shell tab="agenda">
        <ListSkeleton count={4} />
      </Shell>
    );
  }

  return (
    <Shell tab="agenda">
      <div class={dt ? 'toolbar' : ''}>
        <input
          type="text"
          placeholder="Buscar…"
          value={searchQuery.value}
          style={dt ? {} : { marginBottom: 8 }}
          onInput={(e) => (searchQuery.value = (e.target as HTMLInputElement).value)}
        />
        <select
          style={{ width: 'auto', ...(dt ? { minWidth: 140 } : { marginBottom: 8 }) }}
          value={filterEstado.value}
          onChange={(e) => (filterEstado.value = (e.target as HTMLSelectElement).value)}
        >
          <option value="">Todos</option>
          <option value="agendada">Agendadas</option>
          <option value="en_curso">En curso</option>
          <option value="completada">Completadas</option>
          <option value="fallida">Fallidas</option>
        </select>
        <button
          class="primary"
          style={dt ? { width: 'auto', marginTop: 0, padding: '10px 20px' } : { marginBottom: 12 }}
          onClick={() => route('/visitas/nueva')}
        >
          <Icon name="plus" size={16} />
          Agendar
        </button>
      </div>

      {sinTomar.length > 0 && (
        <>
          <h3 style={{ margin: '8px 0', color: 'var(--warning)' }}>
            Disponibles para tomar ({sinTomar.length})
          </h3>
          {dt ? <VisitsTable list={sinTomar} /> : sinTomar.map((v) => <VisitCard key={v.id} v={v} />)}
        </>
      )}

      <h3 style={{ margin: '12px 0 8px' }}>Mis pendientes ({pen.length})</h3>
      {pen.length ? (
        dt ? (
          <VisitsTable list={pen} />
        ) : (
          pen.map((v) => <VisitCard key={v.id} v={v} />)
        )
      ) : (
        <div class="empty">
          <Icon name="clipboard-check" />
          <p>Sin pendientes por ahora.</p>
        </div>
      )}

      {comp.length > 0 && (
        <>
          <h3 style={{ margin: '20px 0 8px' }}>Completadas ({comp.length})</h3>
          {dt ? (
            <VisitsTable list={comp.slice(0, 20)} />
          ) : (
            comp.slice(0, 20).map((v) => <VisitCard key={v.id} v={v} />)
          )}
        </>
      )}
    </Shell>
  );
}
